module.exports = __webpack_public_path__ + "img/ico5.8b34c0bc.png";